import { MOBILE_STORY_QUERY, storyFrameUrl } from '../utils/story-frames'

type StoryPictureProps = {
  frame: number
  alt?: string
  className?: string
  loading?: 'eager' | 'lazy'
  fetchPriority?: 'high' | 'low' | 'auto'
}

/** A story frame framed for the viewport, as AVIF where the browser supports it. */
export function StoryPicture({ frame, alt = '', className, loading, fetchPriority }: StoryPictureProps) {
  return <picture className={className}>
    <source media={MOBILE_STORY_QUERY} type="image/avif" srcSet={storyFrameUrl('mobile', 'avif', frame)} />
    <source media={MOBILE_STORY_QUERY} srcSet={storyFrameUrl('mobile', 'webp', frame)} />
    <source type="image/avif" srcSet={storyFrameUrl('desktop', 'avif', frame)} />
    {/* Pre-encoded sequence frames are served directly, without recompression. */}
    <img src={storyFrameUrl('desktop', 'webp', frame)} alt={alt} loading={loading} fetchPriority={fetchPriority} />
  </picture>
}
